import { useStickyContext } from '@modules/Sticky/StickyContext';

export const useSticky = () => {
  const { isSticky } = useStickyContext();
  return [isSticky];
};

export default useSticky;
